import { Navigate, useParams } from 'react-router-dom';

// import { useGetCategoryProduct } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveSubcategoriaIncidente } from '../../shared/components/SaveSubcategoriaIncidente';
import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';
// import { useGetCategoriaIncidentes } from '@/shared/actions/erp/categoria-incidentes';
import { useGetSubcategoriaIncidencia } from '@/shared/actions/erp/subcategoria-incidentes';

export interface ActSubcategoriaIncidenteInterface {}

const ActSubcategoriaIncidente: React.FC<ActSubcategoriaIncidenteInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_categoria_producto)

  const { id } = useParams();
  const { data, isLoading } = useGetSubcategoriaIncidencia(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_subcategoria_incidencia) return <Navigate to="/tickets-soporte-cliente/subcategoria-incidente" />;

  return <SaveSubcategoriaIncidente titlePage="Editar Subcategoría de Incidencia" editSubcategoriaIncidente={data.data} />;
};

export default ActSubcategoriaIncidente;
